const steps = ["등록", "입문", "작업중", "작업완료", "출문"];
const stepsColor = ["#00CFE8", "#FF9F43", "#EA5455", "#28C76F", "#3C3C3C"];
const getStep = (value) => {
  const body = JSON.parse(value.post_content).body;
  const subStatus = 0; // 입문, 출문 976,979 와 동일하게 getStep 을 사용하도록 하기 위해서 임시로 추가.
  const status = body.상태;

  return Math.max(status, subStatus);
};
const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-select-field",
        label: "사업장명",
        value: "사업장명",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: "",
        },
      },
      {
        component: "search-start-end",
        label: "작업시작일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          // 목록에 오늘 날짜만 보이기 위해서 default 값을 오늘 날짜로 설정하려고 했으나,
          // 오늘날짜부터 혹은 이전 날짜만 보이게 처리하기위해 default 값을 빈값으로 설정하고,
          // 검색하는 부분에서 default 날짜 처리
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-keyword",
        label: "허가번호",
        value: "허가번호",
        query: { fil_2: "keyword" },
        options: {
          default: "",
        },
      },
      {
        component: "search-select",
        label: "진행상태",
        value: "상태",
        query: { s1: "select" },
        options: {
          items: ["전체", "등록", "작업중", "작업완료"],
          default: "",
        },
      },
      {
        component: "search-select",
        label: "구분",
        value: "작업구분",
        query: { s2: "select" },
        options: {
          items: ["전체", "일반보수", "돌발보수", "기타"],
          default: "",
        },
      },
      {
        component: "search-select",
        label: "안전확인여부",
        value: "안전확인여부",
        query: { s3: "select" },
        options: {
          items: ["전체", "Y", "N"],
          default: "",
        },
      },
      {
        component: "search-select",
        label: "중점대상여부",
        value: "중점대상여부",
        query: { s4: "select" },
        options: {
          items: ["전체", "Y"],
          default: "",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "상태", "TBM 여부", "작업시작일", "시작시간", "종료시간", "CCTV1", "CCTV2", "중점대상", "확인<br/>(안환팀)", "연장작업"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.사업장명) {
      conditions.push({
        key: "body.stdInfo.field_name",
        value: `%${search.사업장명.fieldName}%`,
        operator: "LIKE",
      });
    }

    //  일자
    // 목록에 오늘 날짜만 보이기 위해서 default 값을 오늘 날짜로 설정하려고 했으나,
    // 오늘날짜부터 혹은 이전 날짜만 보이게 처리하기위해 default 값을 빈값으로 설정하고,
    // 검색하는 부분에서 default 날짜 처리
    if (!search.date.startDate && !search.date.endDate) {
      conditions.push({ key: "body.작업허가.작업시작일시", operator: ">=", value: new Date().format("yyyy-MM-dd") });
      conditions.push({ key: "body.작업허가.작업시작일시", operator: "<", value: new Date().addDays(1).format("yyyy-MM-dd") });
    } else {
      if (search.date.startDate) {
        conditions.push({ key: "body.작업허가.작업시작일시", operator: ">=", value: search.date.startDate });
      }
      if (search.date.endDate) {
        conditions.push({ key: "body.작업허가.작업시작일시", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
      }
    }

    // 허가번호
    if (search.허가번호) {
      conditions.push({
        key: "body.작업정보.허가번호",
        value: `%${search.허가번호}%`,
        operator: "LIKE",
      });
    }

    // 진행상태 상태: 1~5
    if (search.상태 && search.상태 !== "전체") {
      const searchValue = steps.indexOf(search.상태);
      conditions.push({ key: "body.상태", operator: "=", value: searchValue });
    }

    // 구분
    if (search.작업구분 && search.작업구분 !== "전체") {
      conditions.push({ key: "body.작업구분", operator: "=", value: search.작업구분 });
    }

    // 안전확인여부
    if (search.안전확인여부 && search.안전확인여부 === "Y") {
      conditions.push({ key: "body.안전관계자.확인자유무", operator: "=", value: "y" });
    } else if (search.안전확인여부 && search.안전확인여부 === "N") {
      conditions.push({ key: "body.안전관계자.확인자유무", operator: "=n", value: "n" });
    }

    // 중점대상여부
    if (search.중점대상여부 && search.중점대상여부 === "Y") {
      conditions.push({ key: "body.inspectChecked[%]", operator: "IN", value: ["고소작업", "중장비 작업", "밀폐공간 작업", "방사선 관련 작업", "굴착작업"] });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }

    return conditions;
  },

  /**
   * 목록을 불러온 이후 실제 데이터 값을 list 변수에 저장하기 전에 실행되는 함수 ( this.listAll = response.data 하기 전 )
   * 목록에 표기되는 데이터의 postId 를 배열로 만들어서 TBM 문서 (830)를 조회한다.
   * @param response : 목록데이터
   * @param options : 목록데이터를불러올때사용한옵션
   * @returns {Promise<*>}
   */
  prefixFunc: async (vue, response, options) => {
    const postIds = response.data.map((data) => data.id);

    if (postIds && postIds.length > 0) {
      const conditions = [];
      conditions.push({ key: "body.TBM정보.postId", operator: "IN", value: postIds });
      const res = await vue.$store.dispatch("board/LOAD_POST_LIST", {
        projectId: options.projectId,
        boardId: 830,
        page: 1,
        perPage: options.perPage,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions,
      });

      const tbmList = res && res.data && res.data.length > 0 ? res.data.map((data) => JSON.parse(data.post_content)) : [];
      const tbmJson = {};
      for (let i = 0; i < tbmList.length; i++) {
        const postId = tbmList[i].body.TBM정보.postId;
        if (postId) {
          tbmJson[postId] = tbmList[i];
        }
      }

      // response.data 에 tbmJson 추가
      response.data = response.data.map((data) => {
        return {
          ...data,
          tbmJson: tbmJson[data.id] || undefined,
        };
      });
    }
    return response;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
        style: { width: "100px" },
        pivot: true,
      },
      {
        name: "상태",
        key: "body.상태",
        style: { minWidth: "120px", width: "120px" },
        pivot: true,
      },
      {
        name: "부서명",
        key: "body.작업정보.업체명.com_name",
        style: { minWidth: "150px" },
        pivot: true,
      },
      {
        name: "작업내용",
        key: "body.작업정보.작업내용",
        style: { minWidth: "350px" },
        textDisplay: "wrap",
        pivot: true,
      },
      {
        name: "작업장소",
        key: "body.작업정보.작업장소",
        style: { minWidth: "150px" },
        pivot: true,
      },
      {
        name: "TBM 여부",
        key: "",
      },
      {
        name: "작업시작일",
        key: "body.작업허가.작업시작일시",
      },
      {
        name: "시작시간",
        key: "body.작업허가.작업시간.시작",
      },
      {
        name: "종료시간",
        key: "body.작업허가.작업시간.종료",
      },
      {
        name: "CCTV1",
        key: "body.CCTVs[0]",
      },
      {
        name: "CCTV2",
        key: "body.CCTVs[1]",
      },
      {
        name: "작업유형",
        key: "body.inspectChecked",
      },
      {
        name: "중점대상",
        key: "body.inspectChecked[%]",
      },
      {
        name: "확인<br/>(안환팀)",
        key: "body.안전관계자.확인자유무",
        style: { whiteSpace: "nowrap" },
      },
      {
        name: "연장작업",
        style: { minWidth: "100px" },
        key: "body.작업허가.작업시간.연장",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1: {
          // 상태
          const 상태 = getStep(value);
          return { type: "colorBox", color: stepsColor[상태], text: steps[상태] };
        }
        case 2:
          return func.getContent(value).작업정보.업체명.com_name; // 부서명
        case 3:
          return func.getContent(value).작업정보.작업내용; // 작업내용
        case 4: {
          const form = func.getContent(value);
          return `${form.작업정보.작업구역.region.name} ${form.작업정보.작업구역.zone.name}`; // 작업장소
        }
        case 5: {
          // prefixFunc 에서 tbmJson 을 추가해줬기 때문에 tbmJson 을 가져온다.
          const tbmJson = value.tbmJson;
          // TBM 연동 여부
          if (tbmJson) {
            const body = tbmJson.body;
            const 참석자명단 = body.참석자명단;
            const 사진대지 = body.photoList.filter((e) => e.id);
            const TBM실시시간 = body.TBM정보.TBM실시시간;

            if (참석자명단.length > 0 && 사진대지.length > 0 && TBM실시시간.eTime) {
              return { type: "html", html: `<span style="color:#28C76F">완료</span>` };
            }
          }

          return { type: "html", html: `<span style="color:#EA5455">미진행</span>` };
        }
        case 6:
          return func.getContent(value).작업허가.작업시작일시; // 작업시작일
        case 7:
          return func.getContent(value).작업허가.작업시간.시작; // 시작시간
        case 8:
          return func.getContent(value).작업허가.작업시간.종료; // 종료시간
        case 9: {
          const CCTVs = func.getContent(value).CCTVs;
          if (CCTVs && CCTVs.length > 0) {
            return CCTVs[0].이름;
          }
          return "-";
        }
        case 10: {
          const CCTVs = func.getContent(value).CCTVs;
          if (CCTVs && CCTVs.length > 1) {
            return CCTVs[1].이름;
          }
          return "-";
        }
        case 11:
          return func.getContent(value).inspectChecked.join(", "); // 작업유형
        case 12: {
          const inspectChecked = func.getContent(value).inspectChecked;
          const 중점대상항목 = ["고소", "중장비", "밀폐", "방사선", "굴착"];
          const has중점대상 = inspectChecked && inspectChecked.some((item) => 중점대상항목.some((keyword) => item.includes(keyword)));
          return has중점대상 ? "Y" : "N";
        } // 중점대상
        case 13:
          return `${func.getContent(value).안전관계자.확인자유무}`.toUpperCase(); // 확인(안환팀)
        case 14: {
          const 상태 = func.getContent(value).작업허가.연장승인.상태;
          let color = "#3c3c3c";
          let text = "-";

          if (상태 === "대기") {
            color = "#FF9F43";
            text = "신청 중";
          } else if (상태 === "승인") {
            text = "Y";
          } else if (상태 === "반려") {
            text = "N";
          }
          return { type: "html", html: `<span style="font-weight: bold; color:${color}">${text}</span>` };
        } // 연장작업
        case 15:
          return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
  // 각행의 스타일을 설정하는 부분
  getRowStyle: (value) => {
    if (value.post_content) {
      const postContent = JSON.parse(value.post_content);
      const status = postContent.body.작업허가.연장승인.상태;
      const hasExtension = status !== "없음";

      // "중점대상" 값이 "Y" 인 경우, 붉은 계열 음영을 추가한다
      const inspectChecked = postContent.body.inspectChecked;
      const 중점대상항목 = ["고소", "중장비", "밀폐", "방사선", "굴착"];
      const has중점대상 = inspectChecked && inspectChecked.some((item) => 중점대상항목.some((keyword) => item.includes(keyword)));

      // 두 조건을 모두 확인하여 적절한 색상 적용
      if (hasExtension && has중점대상) {
        // 연장승인(회색)과 중점대상(붉은색)이 모두 해당되는 경우 - 혼합 색상
        return {
          backgroundColor: "#e8d4d4", // 회색과 붉은색을 혼합한 색상
        };
      } else if (hasExtension) {
        // 연장승인만 해당되는 경우 - 회색
        return {
          backgroundColor: "#dddddd",
        };
      } else if (has중점대상) {
        // 중점대상만 해당되는 경우 - 붉은 계열
        return {
          backgroundColor: "#ffebee",
        };
      }
    }
  },
};
export default list;
